import { render } from "./Message.vue?vue&type=template&id=4a5257f6&scoped=true&ts=true"
import script from "./Message.vue?vue&type=script&lang=ts"
export * from "./Message.vue?vue&type=script&lang=ts"

import "./Message.vue?vue&type=style&index=0&id=4a5257f6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a5257f6"]])

export default __exports__